import { instance } from 'helpers/http';

export type VideoCallSchedule = {
  id: string;
  end_at: string;
  start_at: string;
};

export type VideoCallScheduleBook = {
  video_call_id: string;
  schedule: {
    start_at: string;
    end_at: string;
  };
  url: string;
};

const headers = {
  'Content-Type': 'application/json',
  'partner-id': process.env.REACT_APP_PARTNER_ID
};

const VideoCallService = {
  getVideoCallSchedule: async ({ id }: { id: string }) => {
    return await instance.get<VideoCallSchedule[]>(`/v1/ibb/video-calls/schedules`, {
      headers: {
        ...headers,
        'submission-id': id
      }
    });
  },
  bookVideoCallSchedule: async ({ id, data }: { id: string; data: { video_call_schedule_id: string }[] }) => {
    return await instance.post<VideoCallScheduleBook[]>('/v1/ibb/video-calls/book', data, {
      headers: { ...headers, 'submission-id': id }
    });
  }
};

export default VideoCallService;
